<div class="izy-page d-flex justify-content-center align-items-center">
  @if (isLoading) {
  <div
    class="izy-panel izy-panel--loading custom-card-border izy-sharp-bl text-center"
  >
    <h1 class="izy-panel-title mb-4">La tua fantastica App sta caricando</h1>

    <mat-progress-spinner
      class="izy-spinner"
      mode="indeterminate"
      diameter="70"
      strokeWidth="5"
    ></mat-progress-spinner>

    <p class="izy-panel-subtitle mt-4 mb-0">Attendi solo un istante...</p>

    @if (currentTip) {
    <div class="izy-tips" aria-live="polite">
      <div class="izy-tips-label">
        <mat-icon class="izy-tips-icon">lightbulb</mat-icon>
        Suggerimenti
      </div>
      <!-- Il @for su un solo elemento ricrea il paragrafo a ogni cambio di
           frase, cosi' l'animazione di ingresso riparte ogni volta. -->
      @for (tip of [currentTip]; track tip) {
      <p class="izy-tips-text mb-0">{{ tip }}</p>
      }
    </div>
    }
  </div>
  } @if (!isLoading) {
  <div class="izy-panel custom-card-border izy-sharp-bl">
    <div
      class="d-flex justify-content-center align-items-center flex-column text-center"
    >
      <img class="izy-hero-image" src="izy_image_3_small.png" alt="Home image" />
      <h2 class="izy-panel-title mt-3 mb-1">Seleziona la tua Partita IVA:</h2>
      <p class="izy-panel-subtitle mb-0">A quale account vuoi accedere?</p>
    </div>

    <div class="izy-org-list d-flex justify-content-center align-items-center flex-column">
      @for (org of organizations; track org.id) {
      <!-- Il ritardo cresce con la posizione: le partite IVA entrano una dopo
           l'altra invece che tutte insieme. L'animazione sta sul contenitore e
           non sul pulsante, cosi' non litiga col transform del suo hover. -->
      <div class="izy-org-item" [style.animation-delay.ms]="$index * 60">
        <button
          matButton="filled"
          type="button"
          class="izy-org-button izy-button-primary custom-button-border"
          [routerLink]="['/', org.id, 'dashboard']"
        >
          {{ org.name }}
        </button>
      </div>
      } @if (organizations.length === 0) {
      <div class="izy-empty-state text-center">
        <div>Non hai ancora registrato nessuna Partita Iva sul nostro Servizio.</div>
        <div class="mt-3 text-muted">Hai necessità? Contattaci senza impegno: {{email}}</div>
        <div class="mt-3 text-muted">Oppure:</div>
      </div>
      <!-- TODO: registrazione di una nuova organizzazione non ancora approvata, da implementare -->
      <div class="d-flex justify-content-center align-items-center flex-column">
        <!-- <button
          (click)="bookCallRedirect()"
          matButton="filled"
          type="button"
          class="izy-org-button izy-button-primary custom-button-border"
        >
        <mat-icon>co_present</mat-icon>
          Prenota una consulenza gratuita
        </button> -->
      </div>
      }

      <button
        (click)="goToLogout()"
        matButton="outlined"
        type="button"
        class="izy-logout-button izy-button-ghost custom-button-border"
      >
        <mat-icon>logout</mat-icon>
        Logout
      </button>
    </div>

    <!-- <div class="mt-2 d-flex justify-content-center align-items-center flex-column">
      <p>oppure</p>

      <button
        matButton="filled"
        type="button"
        class="izy-org-button izy-button-primary custom-button-border"
        [routerLink]="['/', 'new-organization']"
      >
      <mat-icon>add</mat-icon>
        Crea nuova organizzazione
      </button>
    </div> -->
  </div>
  }
</div>
